import {
  BooleanInput,
  Edit,
  HttpError,
  ImageField,
  ImageInput,
  SimpleForm,
  TextInput,
  useNotify,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import { API_BASE_URL_ADMIN } from 'shared/config';
import { API_URL } from 'shared/constants/api-url';
import { LABELS } from 'shared/constants/labels';
import { httpClient, getErrors } from 'shared/services/http-client';
import { uploadFile } from 'shared/utils/upload-file';
import { Alert, Typography } from '@mui/material';
import {useState} from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

export const CompaniesEdit = () => {
  const { id } = useParams();
  const notify = useNotify();

  const [error, setError] = useState<string | undefined>();
  const [errors, setErrors ] = useState<string[]>([]);

  const handleSubmit = async ({ name, avatarKey, therapistsFilters }: any) => {
    setError(undefined);
    setErrors([]);

    if (!id) return;

    let newAvatarKey = undefined;

    if (avatarKey?.rawFile) {
      const uploadedFile = await uploadFile(avatarKey?.rawFile);
      newAvatarKey = uploadedFile.key;
    }

    const { priceMin, priceMax, coaches } = therapistsFilters;

    try {
      await httpClient(`${API_BASE_URL_ADMIN}${API_URL.editCompany(id)}`, {
        method: 'PATCH',
        body: JSON.stringify({
          name,
          avatarKey: newAvatarKey,
          therapistsFilters: { priceMin: priceMin || null, priceMax: priceMax || null, coaches },
        }),
      });

      notify('Данные о компании обновлены', { type: 'success' });
    } catch (httpError) {
      if (httpError instanceof HttpError) {
        const [error, errors] = getErrors(httpError);

        setError(error);
        setErrors(errors);
      }

      notify('Что-то пошло не так...', { type: 'error' });
    }
  };

  return (
    <Edit>
      {error && (
          <Alert severity="error" variant="filled" sx={{ m: 2 }}>
            <>
              {error}{errors.length > 0 && <>:</>}
              {errors.length > 0 && (
                  <List>
                    {errors.map((error, index) => (
                        <ListItem key={`error-${index}`}>{error}</ListItem>
                    ))}
                  </List>
              )}
            </>
          </Alert>
      )}

      <SimpleForm onSubmit={handleSubmit}>
        <TextInput label={LABELS.companyName} source="name" fullWidth />
        <ImageField
          label="Текущая фотография"
          source="owner.avatarKey"
          sx={{
            '& .RaImageField-image': {
              width: 300,
              height: 300,
              objectFit: 'cover',
            },
          }}
        />
        <ImageInput source="avatarKey" label={LABELS.avatarKey}>
          <ImageField source="src" title="title" />
        </ImageInput>
        <Typography variant="h6">Дополнительные фильтры каталога терапевтов</Typography>
        <TextInput label={LABELS.priceMin} source="therapistsFilters.priceMin" fullWidth/>
        <TextInput label={LABELS.priceMax} source="therapistsFilters.priceMax" fullWidth/>
        <BooleanInput label={LABELS.onlyCoaches} source="therapistsFilters.coaches"/>
      </SimpleForm>
    </Edit>
  );
};
